import Vue from "vue";
import VueRouter from "vue-router";
import HomeAffiliate from "../views/HomeAffiliate.vue";
import PinListBatchWises from "../views/PinListBatchWise.vue";
import loginView from "../views/Login.vue";

/*------------------Dashboard Module Start---------------------- */
import Home from "../views/Dashboard/Home.vue";


/*------------------Dashboard Module End---------------------- */

//Rate Plan
// import AddRatePlans from "../views/RatePlan/AddRatePlan.vue";
// import RatePlans from "../views/RatePlan/RatePlan.vue";
// import EditRatePlans from "../views/RatePlan/EditRatePlan.vue";
// import SaleingRatePlans from "../views/RatePlan/SaleingRatePlan.vue";

/*------------------Rate Plan Module End---------------------- */

/*------------------Client Module Start---------------------- */
//Resellers
import ResellerLists from "../views/Client/Resellers/ResellerList.vue";
import AddNewResellers from "../views/Client/Resellers/AddNewReseller.vue";
import EditResellers from "../views/Client/Resellers/EditReseller.vue";

//Single PIN
import PinLists from "../views/Client/SinglePIN/PinList.vue";
import AddSinglePins from "../views/Client/SinglePIN/AddSinglePin.vue";

//Connected PIN
import ResellerConnectedUsers from "../views/Client/ConnectedPIN/ResellerConnectedUser.vue";

//PIN Batch
import AddPinBatchs from "../views/Client/PinBatch/AddPinBatch.vue";
import EditBatchs from "../views/Client/PinBatch/EditBatch.vue";
import PinBatchLists from "../views/Client/PinBatch/PinBatchList.vue";
import TransferLots from "../views/Client/PinBatch/TransferLot.vue";

//Settings
import AddPanelSettings from "../views/Settings/AddPanelSetting.vue";
import BaseRatePlans from "../views/Settings/BaseRatePlan.vue";

/*------------------Client Module End---------------------- */

/*------------------Report Module Start---------------------- */
//PIN
import PinSubscriptionReportView from "../views/reports/PIN/PinSubscriptionReport.vue";
import IndividualSoldPinReportView from "../views/reports/PIN/IndividualSoldPinReport.vue";
import HourlySubscriptionReportView from "../views/reports/PIN/HourlySubscriptionReport.vue";
//Transaction
import ResellerTransactionReportView from "../views/reports/Transaction/ResellerTransactionReport.vue";
import OnlineTransactionReportView from "../views/reports/Transaction/OnlineTransactionReport.vue";
import PaymentReportView from "../views/reports/Transaction/PaymentReport.vue";
/*------------------Report Module End---------------------- */

import EditSaleRates from "../views/EditSaleRate.vue";
//import CampaignSubscriptionReportView from "../views/reports/CampaignSubscriptionReport.vue";
import CampaignSaleReportView from "../views/reports/CampaignSaleReport.vue";
import CampaignLists from "../views/CampaignList.vue";
import BillingAccountLists from "../views/BillingAccountList.vue";
import AddBillingAccounts from "../views/AddBillingAccount.vue";
import WithdrawLists from "../views/WithdrawList.vue";
import AddNewWithdrawals from "../views/AddNewWithdrawal.vue";
import passwordResetView from "../views/PasswordReset.vue";

import FlexPinLists from "../views/Flex/PinList.vue";
import FlexAddSinglePins from "../views/Flex/AddSinglePin.vue";
import FlexAddPinBatchs from "../views/Flex/AddPinBatch.vue";
import FlexPinBatchLists from "../views/Flex/PinBatchList.vue";
import FlexEditBatchs from "../views/Flex/EditBatch.vue";
import FlexPinListBatchWises from "../views/Flex/PinListBatchWise.vue";
import FlexPinSubscriptionReportView from "../views/reports/Flex/PinSubscriptionReport.vue";
import FlexPaymentReportView from "../views/reports/Flex/PaymentReport.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/:panel",
    redirect: { name: 'loginView' }
  },
  {
    path: "/:panel/dashboard",
    name: "Home",
    component: Home,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/affiliate-dashboard",
    name: "HomeAffiliate",
    component: HomeAffiliate,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/login",
    name: "loginView",
    component: loginView,
  },
  {
    path: "/:panel/resellerlist",
    name: "ResellerLists",
    component: ResellerLists,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/campaignlist",
    name: "CampaignLists",
    component: CampaignLists,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/resellerlist/:id",
    name: "EditResellers",
    component: EditResellers,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/pinlist",
    name: "PinLists",
    component: PinLists,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/pinlist/:id",
    name: "PinListBatchWises",
    component: PinListBatchWises,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/addresellers",
    name: "AddNewResellers",
    component: AddNewResellers,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/billingaccountlists",
    name: "BillingAccountLists",
    component: BillingAccountLists,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/addbilllingaccounts",
    name: "AddBillingAccounts",
    component: AddBillingAccounts,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/editbilllingaccounts/:id",
    name: "EditBillingAccounts",
    component: AddBillingAccounts,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/withdrawlist",
    name: "WithdrawLists",
    component: WithdrawLists,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/addnewwithdrawal",
    name: "AddNewWithdrawals",
    component: AddNewWithdrawals,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/editwithdrawal/:id",
    name: "EditWithdrawals",
    component: AddNewWithdrawals,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/addsinglepin",
    name: "AddSinglePins",
    component: AddSinglePins,
    meta: { requiresAuth: true }
  },
  // {
  //   path: "/:panel/addrateplans",
  //   name: "AddRatePlans",
  //   component: AddRatePlans,
  //   meta: { requiresAuth: true }
  // },
  {
    path: "/:panel/baserateplans",
    name: "BaseRatePlans",
    component: BaseRatePlans,
    meta: { requiresAuth: true }
  },
  // {
  //   path: "/:panel/rateplans",
  //   name: "RatePlans",
  //   component: RatePlans,
  //   meta: { requiresAuth: true }
  // },
  // {
  //   path: "/:panel/edit_rateplans/:id",
  //   name: "EditRatePlans",
  //   component: EditRatePlans,
  //   meta: { requiresAuth: true }
  // },
  // {
  //   path: "/:panel/rateplans/:id",
  //   name: "SaleingRatePlans",
  //   component: SaleingRatePlans,
  //   meta: { requiresAuth: true }
  // },
  {
    path: "/:panel/editsalerate/:id",
    name: "EditSaleRates",
    component: EditSaleRates,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/addpinbatchs",
    name: "AddPinBatchs",
    component: AddPinBatchs,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/edit_batch/:id",
    name: "EditBatchs",
    component: EditBatchs,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/transfer_lot/:id",
    name: "TransferLots",
    component: TransferLots,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/pinbatchlist",
    name: "PinBatchLists",
    component: PinBatchLists,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/resellerconnectedusers",
    name: "ResellerConnectedUsers",
    component: ResellerConnectedUsers,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/panelsettings",
    name: "AddPanelSettings",
    component: AddPanelSettings,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/pinsubscriptionreport",
    name: "PinSubscriptionReportView",
    component: PinSubscriptionReportView,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/onlinetransactionreport",
    name: "OnlineTransactionReportView",
    component: OnlineTransactionReportView,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/transactionreport",
    name: "ResellerTransactionReportView",
    component: ResellerTransactionReportView,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/paymentreport",
    name: "PaymentReportView",
    component: PaymentReportView,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/individualsoldpinreport",
    name: "IndividualSoldPinReportView",
    component: IndividualSoldPinReportView,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/hourlysubscriptionreport",
    name: "HourlySubscriptionReportView",
    component: HourlySubscriptionReportView,
    meta: { requiresAuth: true }
  },
  // {
  //   path: "/:panel/campaignsubscriptionreport",
  //   name: "CampaignSubscriptionReportView",
  //   component: CampaignSubscriptionReportView,
  //   meta: { requiresAuth: true }
  // },
  {
    path: "/:panel/campaignsalereport",
    name: "CampaignSaleReportView",
    component: CampaignSaleReportView,
    meta: { requiresAuth: true }
  },
  {
    path: "/pagenotfound",
    name: "pagenotfound",
    component: () => import("../components/404NotFound.vue")
  },
  {
    path: "/:panel/pagenotfound",
    name: "pagesnotfound",
    component: () => import("../components/404NotFound.vue")
  },
  {
    path: "/:panel/logout",
    redirect: { name: 'loginView' }
  },
  {
    path: "/:panel/passwordReset",
    name: "passwordReset",
    component: passwordResetView,
  },
  {
    path: "/:panel/flexpinlist",
    name: "FlexPinLists",
    component: FlexPinLists,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/addflexsinglepin",
    name: "FlexAddSinglePins",
    component: FlexAddSinglePins,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/addflexpinbatchs",
    name: "FlexAddPinBatchs",
    component: FlexAddPinBatchs,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/flexpinbatchlist",
    name: "FlexPinBatchLists",
    component: FlexPinBatchLists,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/edit_flex_batch/:id",
    name: "FlexEditBatchs",
    component: FlexEditBatchs,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/flexpinlist/:id",
    name: "FlexPinListBatchWises",
    component: FlexPinListBatchWises,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/flexpinsubscriptionreport",
    name: "FlexPinSubscriptionReportView",
    component: FlexPinSubscriptionReportView,
    meta: { requiresAuth: true }
  },
  {
    path: "/:panel/flexpaymentreport",
    name: "FlexPaymentReportView",
    component: FlexPaymentReportView,
    meta: { requiresAuth: true }
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  if(to.matched.some(record => record.meta.requiresAuth)) {
    if (localStorage.getItem("jwt_token") == null) {
      var panelName = to.params.panel;
      if(panelName){
        next({
          name: "loginView",
          params: {panel : panelName}
        });  
      }else{
        next({
          path: "pagenotfound"
        });
      }

    } else {
      next();  
    }
  } else {
    if(to.name=='loginView'){
      if (localStorage.getItem("jwt_token") == null) {
        next();
      }else{
        var panelName = to.params.panel;
        next({
          name: "Home",
          params: {panel : panelName}
        }); 
      }
    }else{
      next();
    }
  }
});

export default router;
